<div class="form-content">
    <div class="list-container">
        <mat-form-field class="search-input">
            <i matPrefix class="tce-icon-search"></i>
            <input matInput type="text"
                   data-qa-label="FilterInput"
                   [placeholder]="filterLabel"
                   (keyup)="onFilter(filterText)"
                   [(ngModel)]="filterText">
            <button mat-icon-button *ngIf="filterText" matSuffix
                    [attr.aria-label]=" 'form.button.clear' | translate " (click)="filterText='';onFilter('');">
                <i class="tce-icon-close"></i>
            </button>
        </mat-form-field>
        <div class="list">
            <div class="list-items">
                <div *ngFor="let item of itemList"
                     data-qa-label="ListItem"
                     (click)="onSelectItem(item)"
                     [ngClass]="{'selected': selectedItem === item}"
                     class="item">
                    <span class="highlight-icon" [ngClass]="{'active': this.showItemHighlightFn(item)}">
                        <i class="tce-icon-link"></i>
                    </span>
                    <span class="name">{{item.name}}</span>
                    <span>
                        <i class="tce-icon-chevron-right"></i>
                    </span>

                </div>
            </div>
            <div class="list-actions" *ngIf="showActionButtons">
                <txp-button [style]="buttonStyle.LISTACTION"
                            (click)="handleNew()"
                            data-qa-label="NewButton"
                            icon="tce-icon-add">
                    {{ 'menu.common.newBtn' | translate }}
                </txp-button>
                <txp-button [style]="buttonStyle.LISTACTION"
                            (click)="handleDuplicate()"
                            data-qa-label="DuplicateButton"
                            icon="tce-icon-duplicate">
                    {{ 'menu.common.duplicateBtn' | translate }}
                </txp-button>
                <txp-button [style]="buttonStyle.LISTACTION"
                            (click)="handleDelete()"
                            data-qa-label="DeleteButton"
                            icon="tce-icon-trash">
                </txp-button>
            </div>
        </div>
        <div class="instruction" *ngIf="highlightInstructions">
            <span class="highlight-icon">
                <i class="tce-icon-link"></i>
            </span>
            {{ highlightInstructions }}
        </div>
    </div>
    <div class="catalog-item-view">
        <ng-content></ng-content>
    </div>
</div>
